// Bridges the brand-agnostic logout menu item (layout-ui) to the app's logout
// logic (casino), which can't be imported across the package / web-component
// boundary. The event name is the shared contract — both sides use these helpers.
const PROFILE_LOGOUT_EVENT = "profile:logout";

export const dispatchProfileLogout = (): void => {
  window.dispatchEvent(new Event(PROFILE_LOGOUT_EVENT));
};

export const onProfileLogout = (handler: () => void): (() => void) => {
  window.addEventListener(PROFILE_LOGOUT_EVENT, handler);
  return () => window.removeEventListener(PROFILE_LOGOUT_EVENT, handler);
};
